module.exports = __webpack_public_path__ + "static/media/chat-screen_1.eabee47b.png";